import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { UserService } from '../../services/api/user/user.service';
import { FormField, FormLink, YshFormComponent } from '../../components/ysh-form/ysh-form.component';
import { YshSplitLayoutComponent } from "../../components/ysh-split-layout/ysh-split-layout.component";
import { AppRoutes } from '../../app.routes';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { emailValidator } from '../../components/ysh-form/validators/email.validator';
import { LoadingService } from '../../services/ui/loading/loading.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [YshFormComponent, YshSplitLayoutComponent]
})
export class LoginComponent {

  formFields: FormField[] = [
    {
      name: 'email',
      label: 'Email Address',
      type: 'email',
      icon: 'alternate_email',
      validators: [Validators.required, emailValidator()]
    },
    { 
      name: 'password',
      label: 'Password',
      type: 'password',
      icon: 'lock',
      validators: [Validators.required]
    },
  ];

  formLinks: FormLink[] = [
    {
      route: AppRoutes.Signup,
      label: 'Create Account',
      queryParamsHandling: 'preserve',
    },
    {
      route: AppRoutes.Password,
      label: 'Login Trouble?',
    },
  ]

  constructor(private analytics: AnalyticsService, private userService: UserService, private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.analytics.trackView('LoginComponent');
  }

  async handleLogin(formValues: any): Promise<void> {  
    try {
      await firstValueFrom(
        this.userService.login(formValues.email, formValues.password)
      );
      this.loadingService.loadingShow(1000);
    } catch (error) {
      console.error(error);
      throw error; // Throw error for YshFormComponent to handle
    }
  }
}
